{
  "appName": "0839",
  "entryFile": "./app-entry.jsx",
  "entryName": "0839-edu-benefits",
  "rootUrl": "/school-administrators/submit-yellow-ribbon-program-agreement-form-22-0839",
  "productId": "27f9178f-3aa0-41cb-904d-d5a2326b0b4c"
}
